import { render, staticRenderFns } from "./rating-quality.vue?vue&type=template&id=71103123"
import script from "./rating-quality.vue?vue&type=script&lang=ts"
export * from "./rating-quality.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports